import { httpClient } from '@bcba/client-auth';
import { ExplorerCurrentUserSerializer } from '@bcba/serializers';
import { basePathUsers } from '.';

export const getCurrentUser =
  async (): Promise<ExplorerCurrentUserSerializer> => {
    const { data } = await httpClient.get<ExplorerCurrentUserSerializer>(
      `${basePathUsers}/current`,
    );

    return data;
  };
